Drupal.behaviors.submenuToggle = {
  attach: function (context) {
    const submenuToggles = context.querySelectorAll(".submenu-toggle");

    // Helper function to close all menus
    function closeAllMenus() {
      submenuToggles.forEach((toggle) => {
        toggle.classList.remove("open");
        toggle.setAttribute("aria-expanded", "false");
        const subMenu = toggle.nextElementSibling;
        if (subMenu) {
          subMenu.classList.remove("sub-menu--open");
        }
      });
    }

    submenuToggles.forEach((toggle) => {
      if (toggle.dataset.submenuToggleBound === "true") {
        return;
      }
      toggle.dataset.submenuToggleBound = "true";

      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        const subMenu = toggle.nextElementSibling;
        const isCurrentlyOpen = toggle.classList.contains("open");
        
        // Close all menus first
        closeAllMenus();
        
        // If this menu wasn't open, open it
        if (!isCurrentlyOpen && subMenu) {
          toggle.classList.add("open");
          toggle.setAttribute("aria-expanded", "true");
          subMenu.classList.add("sub-menu--open");
        }
      });
    });
  },
};
